module.exports = __webpack_public_path__ + "img/aboutATF.aca08c5f.jpg";